module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "p1h2"
    }
  }, [_c('h3', {
    staticClass: "h3",
    attrs: {
      "id": "p1h1"
    }
  }, [_c('span', {
    staticClass: "font100"
  }, [_vm._v("A Press Interview with Five Veterans")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "font01"
  }, [_vm._v("(From "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Winners of the West")]), _vm._v(", July, 1940)")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Last month Camp 36, [National Indian War Veterans, ] Philadelphia, gained national interest anew. It all came about in this manner: a columnist of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Philadelphia Inquirer")]), _vm._v(" voluntarily commented upon the Indian War Veterans’ rally held May 12 [1940] at the home of their State Commander, Ralph Edwards of Malvern, Pennsylvania. The comment, though brief, was followed by a series of interviews which were published in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Evening")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bulletin")]), _vm._v(". These interviews included all of the veterans that the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bulletin")]), _vm._v(" could reach in and around Philadelphia. These interviews translated the veteran from a shadowy figure into a hero of valiant deeds worthy of attention. Following are some extracts from each of the interviews. Each interview has been cut down considerably as they were quite lengthy and accompanied by several pictures, as published originally in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Evening Bulletin")]), _vm._v(" of Philadelphia.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c33b1796","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/IndianWarVeterans_p12.vue
// module id = 135
// module chunks = 0